import { lazy } from 'react';
import type { RouteObject } from 'react-router';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const PublicDoctorPage = lazy(() => import('./pages/PublicPage'));

/** Página pública do médico (T-18) — {subdominio}.azanas.me ou /m/:subdominio. Pública, sem login. */
const routes: RouteObject[] = [
  { path: '/m/:subdominio', element: <PublicDoctorPage /> },
];
export default routes;
